/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {
  $("#accordion > li > h3").click(function(){

		if(false == $(this).next().is(':visible')) {
			$('#accordion ul').slideUp(300);
		}
	
		var classnm = $(this).parent('li').attr("class");
		// Line Added to remove the active class from all 'li'
		$('#accordion > li').removeClass('active');
		// Line Added to remove the blank attribute of class from all 'li'
		$('#accordion > li[class=""]').removeAttr('class');
		// Line Added to add the active class in current 'li'
	
		$(this).next().slideToggle(300);
	
		if(classnm == "undefined" || classnm == "" || classnm == undefined){
			$(this).parent('li').addClass('active');
		}
	});

	$('#accordion ul:eq(0)').hide();
	$("#accordion li").eq(0).addClass("active");
	$("#accordion li").eq(0).find("ul").show();
});
